import * as types from './actionTypes'
import * as BusinessTypes from '../Business/actionTypes'

const initialState = {
  isFetching: true,
  location: undefined,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_USER:
      return {
        ...state,
        isFetching: true,
      }
    case types.FETCH_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        sessionError: false,
        details: action.details,
      }
    case types.FETCH_USER_ERROR:
      return {
        ...state,
        isFetching: false,
        sessionError: true,
      }
    case types.FETCH_LOCATION:
      return {
        ...state,
        location: action.location,
      }
    case types.FETCH_BUSINESSES:
      return {
        ...state,
        businesses: action.data,
      }
    case BusinessTypes.UPDATE_BUSINESS_NAME:
      return {
        ...state,
        businesses: state.businesses?.map(record => String(record.businessId) === String(action.businessId)
          ? { ...record, companyInfo: { ...record.companyInfo, companyName: action.name } }
          : record),
      }
    case BusinessTypes.UPDATE_ACCOUNT_NAME:
      return {
        ...state,
        details: state.details?.businessAccount && String(state.details.businessAccount.organizationId) === String(action.organizationId)
          ? { ...state.details, businessAccount: { ...state.details.businessAccount, name: action.name } }
          : state.details,
        businesses: state.businesses?.map(record => String(record.organizationId) === String(action.organizationId)
          ? { ...record, accountName: action.name }
          : record),
      }
    case types.FETCH_FAVORITES:
      return {
        ...state,
        favorites: action.favorites,
      }
    case types.UPDATE_FAVORITE: {
      const favorites = Array.isArray(state.favorites) ? state.favorites : []
      return {
        ...state,
        favorites: action.isFavorite
          ? Array.from(new Set([...favorites, action.offerId]))
          : favorites.filter((offerId) => offerId !== action.offerId),
      }
    }
    case BusinessTypes.UPDATE_BUSINESS_COMPANY_INFO:
      // Update company info of updated business.
      const companyInfo = action.companyInfo
      const currentBusinessRecord = state.businesses.find(
        (record) => record.businessId === companyInfo.businessId
      )

      const newBusinessRecord = {
        ...currentBusinessRecord,
        companyInfo: {
          ...companyInfo,
        },
      }

      return {
        ...state,
        businesses: state.businesses
          .filter((record) => record.businessId !== companyInfo.businessId)
          .concat([newBusinessRecord]),
      }
    case types.CLEANUP_BUSINESSES:
      return {
        ...state,
        businesses: undefined,
      }
    case types.LOGOUT:
      return {
        location: state.location,
        isFetching: false,
      }
    default:
      return state
  }
}

export default userReducer
